import { COOKIE_CONSENT_ACCEPTED_KEY } from "constants/localStorage";
import { generateUuid } from "helpers/uuid";

export const clearLocalStorage = () => {
    const themeValue = localStorage.getItem("theme");
    const deviceId = localStorage.getItem("deviceId");
    const cookieConsentAccepted = localStorage.getItem(COOKIE_CONSENT_ACCEPTED_KEY);

    localStorage.clear();
    localStorage.setItem("theme", themeValue ?? "light");
    localStorage.setItem("deviceId", deviceId ?? generateUuid());

    if (cookieConsentAccepted) {
        localStorage.setItem(COOKIE_CONSENT_ACCEPTED_KEY, cookieConsentAccepted);
    }
};

/** Return whether the current session was opened through login-by-user. */
export const isImpersonatingUser = () => localStorage.getItem("techUserToken") !== null;
